// projects/humanresources-personnel/src/assets/i18n/*/hr-per-family.json
export class HrPerFamilyKey {
    private static readonly keyPrefix = 'hrPerFamily';
    public static title = `${HrPerFamilyKey.keyPrefix}.title`;
    public static pageHeader = `${HrPerFamilyKey.keyPrefix}.pageHeader`;
    public static objectConnect = `${HrPerFamilyKey.keyPrefix}.objectConnect`;
    public static identificationNumber = `${HrPerFamilyKey.keyPrefix}.identificationNumber`;
    public static peopleNum = `${HrPerFamilyKey.keyPrefix}.peopleNum`;
    public static peopleStatus = `${HrPerFamilyKey.keyPrefix}.peopleStatus`;
    public static allowanceType = `${HrPerFamilyKey.keyPrefix}.allowanceType`;
    public static birthDate = `${HrPerFamilyKey.keyPrefix}.birthDate`;
    public static historyButton = `${HrPerFamilyKey.keyPrefix}.historyButton`;
    public static description = `${HrPerFamilyKey.keyPrefix}.description`;
}
